import PropTypes from 'prop-types';
import styled from 'styled-components';

export const Column = styled.div`
  box-sizing: border-box;

  ${({ size }) =>
    size && size < 12
      ? `
        width: ${(size / 12) * 100}%
        float: left;
      `
      : 'width: 100%; clear: both;'} ${({ sizes }) =>
    sizes &&
    sizes.length &&
    sizes.map(
      ({ breakpoint, size }) => `
    @media (min-width: ${breakpoint}px) {
      ${
        size < 12
          ? `
          width: ${(size / 12) * 100}%;
          float: left;
          clear: none;
        `
          : 'width: 100%; clear: both;'
      }
    }
  `
    )};
`;

Column.propTypes = {
  sizes: PropTypes.arrayOf(
    PropTypes.shape({
      breakpoint: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired
    })
  ),
  size: PropTypes.number,
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/Grid/Column.js